import { Icon, IconProps } from '@jisr-hr/ds-beta'

const DSIcon = (props: IconProps): JSX.Element => <Icon {...props} />

export default DSIcon
